export default {"src":"/_next/static/media/NewProductDevelopment.cc8332a3.svg","height":1186,"width":1094,"blurWidth":0,"blurHeight":0};